module.exports = __webpack_public_path__ + "static/media/cdap_tmpl.d34574fc.svg";